import "./PaymentDelivery.css";

const PaymentDelivery = () => {
    return (
        <div className="payment-page">
            <div className="payment-container">

                <h1 className="payment-title">
                    Доставка и оплата
                </h1>

                <p className="payment-intro">
                    Доставим куда угодно — оплатите удобно
                </p>

                <p>
                    Неважно, где вы находитесь: мы с радостью привезём ваш заказ
                    в любой регион России. Наша команда позаботится о том, чтобы
                    процесс покупки был максимально простым и приятным.
                </p>

                <h2>Оплата</h2>
                <p>
                    Всё просто: после того как вы определитесь с заказом,
                    наш менеджер подготовит для вас счёт — останется только его оплатить.
                    Так вы будете уверены, что платите ровно за то, что выбрали.
                </p>

                <h2>Доставка</h2>
                <p>
                    Стоимость доставки рассчитывается индивидуально — она зависит от того,
                    куда нужно привезти заказ. Наш специалист учтёт все нюансы и заранее
                    сообщит вам точную сумму, чтобы не было никаких неожиданностей.
                </p>

                <p className="payment-footer">
                    Мы ценим ваше время и доверие, поэтому делаем условия доставки
                    и оплаты максимально понятными. Если что-то осталось неясным —
                    просто напишите или позвоните нам, и мы всё подробно расскажем.
                </p>

            </div>
        </div>
    );
};

export default PaymentDelivery;
